import type { PdfBookmarkPages } from './blobStore'

export function pdfBookmarkKey(shareId: string, fingerprint: string): string {
  return `${shareId.trim().toUpperCase()}:${fingerprint}`
}

export function pageForSegno(
  pages: PdfBookmarkPages,
  segnoOrder: number | null,
  totalPages: number,
): number | null {
  if (segnoOrder == null) return null
  const page = pages[String(segnoOrder)]
  if (!Number.isInteger(page) || page < 1 || page > totalPages) return null
  return page
}

export function withSegnoPage(
  pages: PdfBookmarkPages,
  segnoOrder: number,
  page: number,
  totalPages: number,
): PdfBookmarkPages {
  if (!Number.isInteger(segnoOrder) || segnoOrder < 1) return { ...pages }
  const normalizedPage = Math.min(Math.max(1, Math.trunc(page)), Math.max(1, totalPages))
  return { ...pages, [String(segnoOrder)]: normalizedPage }
}

export function withoutSegnoPage(
  pages: PdfBookmarkPages,
  segnoOrder: number,
): PdfBookmarkPages {
  const next = { ...pages }
  delete next[String(segnoOrder)]
  return next
}
